import { format, isToday, isTomorrow } from 'date-fns';
import { MODALITY_LABELS } from '../../data/profile';
import { parseDays, WEEKDAY_LABELS, type PlannedSession, type TreatmentSchedule } from '../../lib/schedule';

export function describeSchedule(schedule: TreatmentSchedule) {
  const days = parseDays(schedule.days_of_week).map((day) => WEEKDAY_LABELS[day]);
  const hours = schedule.duration_min ? `${Math.floor(schedule.duration_min / 60)}h${schedule.duration_min % 60 ? ` ${schedule.duration_min % 60}m` : ''}` : null;
  const details = [schedule.start_time ? `from ${schedule.start_time}` : null, hours, schedule.location, schedule.modality ? MODALITY_LABELS[schedule.modality] : null]
    .filter(Boolean)
    .join(' · ');
  return { days: days.length ? days.join(', ') : 'No days set', details };
}

/** "Today at 08:00", "Tomorrow", "Monday 26 Oct at 08:00". */
export function describeWhen(session: PlannedSession) {
  const day = isToday(session.start) ? 'Today' : isTomorrow(session.start) ? 'Tomorrow' : format(session.start, 'EEEE d MMM');
  return session.time ? `${day} at ${session.time}` : day;
}
